

<div class="called-volume ecall-background-color card-block-off grid-6">
	<div class="row">
		<div class="margin-h">
			<div class="margin-v">
				<div translate class="batch-label">filter.customerOrderNumber</div>
				<div class="card-content-value-cursor">
					<a class="ecall-card-value-color"
					[routerLink]="['/order-tracking/order/card/', volume?.supplierOrderReference,volume?.supplierOrderItem]">
					{{ getCustomerOrderNumber() ??
						UNDERSCORE }}
				</a>
				</div>
			</div>
			<div class="margin-v">
				<div translate class="batch-label">filter.supplierOrderNumber</div>
				<div  class="card-content-value-cursor">
					<a class="ecall-card-value-color"
					[routerLink]="['/order-tracking/order/card/', volume?.supplierOrderReference,volume?.supplierOrderItem]">
					{{ getSupplierOrderNumber() ??
					UNDERSCORE }}</a></div>
			</div>
		</div>
	</div>
	<div class="row large">
		<div class="margin-h">
			<div class="margin-v">
				<div translate class="batch-label">ecall-off.unloading-reference</div>
				<div>{{ volume?.unloadingReference ? volume?.unloadingReference : UNDERSCORE }}</div>
			</div>
			<div class="margin-v">
				<div translate class="batch-label">ecall-off.ship-to</div>
				<div>{{ volume?.originalShipToDescription ?? UNDERSCORE }}</div>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="margin-v">
			<div translate class="batch-label">ecall-off.requested-ship-to</div>
			<div>{{ volume?.shipToDescription ?? UNDERSCORE }}</div>
		</div>
	</div>
	<div class="row">
		<div class="margin-h">
			<div class="margin-v">
				<div translate class="batch-label">order.steelgrade</div>
				<div>{{ volume?.steelgrade ?? UNDERSCORE }}</div>
			</div>
			<div class="margin-v">
				<div translate class="batch-label">order-tracking.dimension</div>
				<div>{{ volume | copoDimension }}</div>
			</div>
		</div>
	</div>
	<div class="row" *ngIf="volume?.requestedDeliveryDateFrom || volume?.requestedDeliveryDateTo">
		<div class="margin-h">
			<div class="margin-v"
				*ngIf="volume?.requestedDeliveryDateFrom && volume?.requestedDeliveryDateFrom === volume?.requestedDeliveryDateTo">
				<div translate class="batch-label">ecall-off.requested-date</div>
				<div>{{ volume?.requestedDeliveryDateFrom | copoDate:'date' }}</div>
			</div>
			<div class="margin-v" *ngIf="volume?.requestedDeliveryDateFrom && !volume?.requestedDeliveryDateTo">
				<div translate class="batch-label">ecall-off.requested-date</div>
				<div>{{ volume?.requestedDeliveryDateFrom | copoDate:'date' }}</div>
			</div>
			<div class="margin-v" *ngIf="volume?.requestedDeliveryDateTo && !volume?.requestedDeliveryDateFrom">
				<div translate class="batch-label">ecall-off.requested-date</div>
				<div>{{ volume?.requestedDeliveryDateTo | copoDate:'date' }}</div>
			</div>
			<ng-container
				*ngIf="volume?.requestedDeliveryDateFrom && volume?.requestedDeliveryDateTo && volume?.requestedDeliveryDateFrom !== volume?.requestedDeliveryDateTo">
				<div class="margin-v">
					<div translate class="batch-label">filter.number.from</div>
					<div>{{ volume?.requestedDeliveryDateFrom | copoDate:'date' }}</div>
				</div>
				<div class="margin-v">
					<div translate class="batch-label">filter.date.to</div>
					<div>{{ volume?.requestedDeliveryDateTo | copoDate:'date' }}</div>
				</div>
			</ng-container>
		</div>
	</div>
	<div class="row large" *ngIf="showComment">
		<div class="row margin-h">
			<mat-icon svgIcon="comment"></mat-icon>
			<div class="margin-h ellipsis">{{volume?.comment ?? UNDERSCORE}}</div>
		</div>
	</div>
	<div class="row">
		<div class="text-center margin-h">
			<div class="text-big margin-v">{{ volume?.requestedVolume }}</div>
			<div translate class="batch-label">ecall-off.called-volume</div>
		</div>
	</div>
</div>